import { useMediaQuery, useTheme } from '@mui/material';

import { AppTheme } from './theme';

export const useIsMobile = () => useMediaQuery<AppTheme>(useTheme().breakpoints.down('desktop'));
